// Dynamic size availability for washed template
document.addEventListener('DOMContentLoaded', () => {
  // Wait for Alpine to be fully loaded
  const initAvailability = () => {
    const productSection = document.querySelector('[data-product-section]');
    if (!productSection) return;
    
    // Get Alpine data
    if (!window.Alpine || !Alpine.$data) {
      setTimeout(initAvailability, 100);
      return;
    }
    
    const alpineData = Alpine.$data(productSection);
    if (!alpineData || !alpineData.product) {
      setTimeout(initAvailability, 100);
      return;
    }
    
    const product = alpineData.product;
    const variants = product.variants;
    
    // Find color and size option indices
    let colorOptionIndex = -1;
    let sizeOptionIndex = -1;
    
    // Options might be strings or objects, handle both
    const optionNames = product.options || [];
    
    optionNames.forEach((option, index) => {
      // Option might be a string or an object with .name
      const optionName = typeof option === 'string' ? option : option.name;
      
      if (optionName) {
        const optionLower = optionName.toLowerCase();
        if (optionLower.includes('color') || optionLower.includes('colour')) {
          colorOptionIndex = index;
        } else if (optionLower.includes('size')) {
          sizeOptionIndex = index;
        }
      }
    });
    
    if (colorOptionIndex === -1 || sizeOptionIndex === -1) return;
    
    // Function to update size availability
    const updateSizeAvailability = () => {
      const selectedColor = alpineData[`currentOption${colorOptionIndex + 1}`];
      if (!selectedColor) return;
      
      // Find all size radio buttons - look for them in the variant picker
      const variantContainer = productSection.querySelector('[data-product-form-variant-container]');
      if (!variantContainer) return;
      
      const sizeRadios = variantContainer.querySelectorAll('input[type="radio"][data-single-option-selector]');
      
      sizeRadios.forEach(radio => {
        const sizeValue = radio.value;
        const radioName = radio.getAttribute('name');
        
        // Skip color options
        if (radioName && (radioName.toLowerCase().includes('colour') || radioName.toLowerCase().includes('color'))) {
          return;
        }
        
        // Find the label for this radio (it's the next sibling)
        const label = radio.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        
        // Find the text span (last span child of label)
        const spans = label.querySelectorAll('span');
        const textSpan = spans[spans.length - 1];
        
        if (!textSpan) return;
        
        // Check if this size+color combination is available
        const isAvailable = variants.some(v => {
          if (!v.available) return false;
          
          // Variant options might be in v.options array or v.option1, v.option2, etc.
          const variantSize = v.options ? v.options[sizeOptionIndex] : v[`option${sizeOptionIndex + 1}`];
          const variantColor = v.options ? v.options[colorOptionIndex] : v[`option${colorOptionIndex + 1}`];
          
          const matchesSize = variantSize === sizeValue;
          const matchesColor = variantColor === selectedColor;
          
          return matchesSize && matchesColor;
        });
        
        // Update styling
        if (isAvailable) {
          textSpan.style.opacity = '1';
          textSpan.style.color = '';
        } else {
          textSpan.style.opacity = '0.5';
          textSpan.style.color = '#999999';
        }
      });
    };
    
    // Watch for color changes
    alpineData.$watch(`currentOption${colorOptionIndex + 1}`, () => {
      updateSizeAvailability();
    });
    
    // Initial update
    setTimeout(updateSizeAvailability, 100);
  };
  
  // Start initialization
  setTimeout(initAvailability, 100);
});

